var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"resumeEditor",class:{htmlMode:_vm.enableHtml}},[(_vm.enableHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.result)}}):_c('pre',[_vm._v(_vm._s(_vm.result))])])}
var staticRenderFns = []

export { render, staticRenderFns }